<template>
  <div>
    <b-container fluid class="px-5">
      <div class="mt-4 d-flex align-items-start justify-content-between">
        <div>
          <h1 class="page-title">Hospitalisations terminées</h1>
          <h2 class="page-subtitle">Total : {{ totalCount }}</h2>
        </div>
      </div>

      <b-card class="mt-2 mb-4 shadow-sm">

        <b122-table
          ref="B122TableHospitalizationArchive"
          identifier="B122TableHospitalizationArchive"
          init-b122-table-url="/hospitalizationArchive/initB122Table"
          get-b122-table-results-url="/hospitalizationArchive/getB122TableResults"
          :fields="tableFields"
          initial-sort-by="endDate"
          :initial-sort-desc="false"
          @setTotalCount="setTotalCount"
          @clickOnShowBtn="clickOnShowBtn"
          @clickOnEditBtn="clickOnEditBtn"
          @clickOnDeleteBtn="clickOnDeleteBtn"
        >
        </b122-table>

      </b-card>
    </b-container>

    <!-- Modal Delete -->
    <hospitalization-delete-modal :selectedHospitalization="ui.selectedHospitalization" @didDeleteHospitalization="didDeleteHospitalization()"></hospitalization-delete-modal>

  </div>
</template>

<script>

import api from '../../services/api';
import B122Table from "../../components/b122/B122Table";
import HospitalizationDeleteModal from "../hospitalization/HospitalizationDeleteModal";

export default {

  name: 'HospitalizationArchiveIndex',

  components: {
    B122Table,
    HospitalizationDeleteModal
  },

  data() {
    return {

      totalCount: 0,

      tableFields: [
        {
          label: "",
          key: "show",
          sortable: false
        },

        {
          label: "Propriétaire",
          key: "animal.user.name",
          sortKey: "animal.user.lastName",
          sortable: true
        },
        {
          label: "Animal",
          key: "animal.name",
          sortable: true
        },
        {
          label: "Espèce",
          key: "animal.species.name",
          sortable: true
        },
        {
          label: "Motif",
          key: "goal",
          sortable: true
        },
        {
          label: "Date de sortie",
          key: "endDate",
          sortable: true,
            formatter: function (value, key, item) {
              return new Date(value).toLocaleDateString('fr-FR');
            }
        },
        {
          label: "",
          key: "actions"
        }
      ],
      ui: {
        selectedHospitalization: null
      }
    }
  },

    methods: {

    setTotalCount(totalCount) {
      this.totalCount = totalCount
    },

    clickOnShowBtn(row) {
      this.$router.push({
        name: 'HospitalizationShow',
        params: {
          hospitalizationId: row.item.id
        }
      })
    },

    clickOnEditBtn(row) {
      this.$router.push({
        name: 'HospitalizationEdit',
        params: {
          hospitalizationId: row.item.id
        }
      })
    },

    clickOnDeleteBtn(row) {
      this.ui.selectedHospitalization = row.item
      this.$bvModal.show('hospitalization-delete-modal')
    },

    didDeleteHospitalization() {
      this.ui.selectedHospitalization = null;
      this.$refs.B122TableHospitalizationArchive.refreshTable()
    }

  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/hospitalizationArchive/HospitalizationArchiveIndex.vue